.wrapper {
  padding: 24px 0;

  ul {
    list-style: none;
  }

  li {
    color: #231e19;
    font-size: 17px;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: 0.051px;

    span {
      font-weight: 700;
    }
  }
}

.list {
  padding-left: 45px;
  position: relative;

  .item1 {
    color: #7b766f;
    margin-bottom: 23px;
    position: relative;
  }

  .item2 {
    margin-bottom: 12px;
    position: relative;
  }

  .item1::after,
  .item2::after {
    content: '';
    display: block;
    position: absolute;
    z-index: 5;
  }

  .item1::after {
    background: url(./img/icn1.png) no-repeat;
    background-size: contain;
    background-position: center;
    width: 28px;
    height: 28px;
    top: 0;
    left: -42px;
  }

  .item2::after {
    background: url(./img/icn2.png) no-repeat;
    background-size: contain;
    background-position: center;
    width: 34px;
    height: 34px;
    left: -45px;
    top: -6px;
  }
}

.listImg {
  position: absolute;
  top: -3px;
  left: 0;
  width: 34px;
  object-fit: contain;
}

.list2 {
  padding-left: 20px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 12px;

  li {
    position: relative;
  }

  li:after {
    content: '';
    display: block;
    width: 16px;
    height: 18px;
    background: url(./img/icn3.png) no-repeat;
    background-size: contain;
    background-position: center;
    position: absolute;
    top: 0;
    left: -20px;
  }
}

// Dark mode
:global body.dark {
  :local {
    .item1,
    .item2,
    .list2 li {
      color: #fffbf2;
    }

    .item2::after {
      background: url(./img/icn2Dark.png) no-repeat;
      background-size: contain;
      background-position: center;
    }
  }
}
